import { type PropsWithChildren, type ReactNode } from "react";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type Props = {
  title?: string;
  description?: ReactNode | string;
  bordered?: boolean;
  headerAction?: ReactNode;
  className?: string;
};

export const SettingsSectionLayout = ({
  title,
  description,
  bordered,
  headerAction,
  children,
  className,
}: PropsWithChildren<Props>) => (
  <div
    className={cnTwMerge(
      "bg-background/primary w-full rounded-lg py-3 px-2 md:p-6",
      bordered && "border border-border/primary",
      className,
    )}
  >
    {title ? (
      <div className="pb-6 pt-4">
        <div className="flex justify-between items-start gap-4">
          <div className="flex-1">
            <h4 className="heading-4">{title}</h4>
            {typeof description === "string" ? (
              <p className="body-base-regular text-text/secondary">
                {description}
              </p>
            ) : (
              description
            )}
          </div>
          {headerAction ? (
            <div className="flex-shrink-0">{headerAction}</div>
          ) : null}
        </div>
      </div>
    ) : null}
    <div className="flex flex-col gap-y-4">{children}</div>
  </div>
);

export const SectionBorder = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => (
  <div
    className={cnTwMerge(
      "border border-border/primary rounded-lg overflow-hidden max-w-6xl w-full",
      className,
    )}
  >
    {children}
  </div>
);
